import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { setDatatableFilter } from '@actions/data-table-actions';
import { getCount, getFilters } from '@selectors/data-table-selector';
import Paginator from '@shared/paginator';
import './footer.scss';

const Footer = ({ dataType, subType }) => {
  const dispatch = useDispatch();
  const stableProps = useMemo(() => ({ dataType, subType }), [dataType, subType]);
  const filters = useSelector(state => getFilters(state, stableProps));
  const count = useSelector(state => getCount(state, stableProps));

  const handleLimitChange = useCallback(limit => {
    // Clamp offset to the new page ranges.
    const currentOffset = filters?.offset || 0;
    const newPage = Math.floor(currentOffset / limit);
    const newOffset = newPage * limit;
    dispatch(setDatatableFilter(dataType, subType, { limit, offset: newOffset }));
  }, [dataType, subType, dispatch, filters]);

  const handleOffsetChange = useCallback(offset => {
    dispatch(setDatatableFilter(dataType, subType, { offset }));
  }, [dataType, subType, dispatch]);

  if (count > 0) {
    const limit = filters?.limit || 50;
    return (
      <div styleName="footer-section">
        <Paginator
          count={count}
          limit={Math.min(limit, count)}
          offset={filters?.offset || 0}
          onLimitChange={handleLimitChange}
          onOffsetChange={handleOffsetChange}
        />
      </div>
    );
  }
  return null;
};

Footer.propTypes = {
  dataType: PropTypes.string,
  subType: PropTypes.string
};

export default memo(Footer);

